import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = (n) => (_pushScopeId("data-v-514c91f6"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "bottomSheetOverlay" };
const _hoisted_2 = { class: "bottomSheet" };
const _hoisted_3 = { class: "title" };
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", { class: "label" }, "Choose Reason", -1));
const _hoisted_5 = { class: "btn-group" };
const _hoisted_6 = {
    key: 0,
    style: { "color": "red" }
};
const _hoisted_7 = {
    key: 1,
    style: { "color": "red" }
};
const _hoisted_8 = { class: "btn-group" };
import DButton from "../button/SubmitButton.vue";
import SearchTextBox from "../search-text-box/SearchTextBox.vue";
import MultiSelectCheckbox from "../multi-select-checkbox/MultiSelectCheckbox.vue";
import CommentBox from "../commentBox/CommentBox.vue";
import { ref, onMounted, toRaw, computed, watch } from "vue";
import axios from "axios";
import { getApiBaseUrl } from "../../apiConfig";
export default /*#__PURE__*/ _defineComponent({
    __name: 'EndTaskSheet',
    props: {
        value: {
            type: String,
            default: "Are you sure you want to start the session?",
        },
    },
    emits: ["close", "start"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        // Define the emit event
        const emit = __emit;
        // Emit an event when the "No" button is clicked
        function handleClose() {
            emit("close");
        }
        // Emit an event when the "Yes" button is clicked
        function handleStart() {
            // Emit the start event with selected options and the comment
            reasonError.value = false;
            commentError.value = false;
            // Validate reasons and comment
            if (selectedOptions.value.length === 0) {
                reasonError.value = true;
            }
            if (!commentText.value.trim()) {
                commentError.value = true;
            }
            // Proceed only if no validation errors
            if (!reasonError.value && !commentError.value) {
                const eventData = {
                    reasons: toRaw(selectedOptions.value),
                    comment: commentText.value,
                };
                console.log("eventData", eventData);
                // Emit the event with the data
                emit("start", eventData); // Sending both selected options and comment to the parent or external component
            }
        }
        // Reactive properties for the selected options and comment
        const selectedOptions = ref([]);
        const commentText = ref("");
        // Create a computed property for rawSelectedOptions that shows the unwrapped value
        const reasonError = ref(false);
        const commentError = ref(false);
        // Create a computed property for rawSelectedOptions that shows the unwrapped value
        // To store the fetched checkbox options (reasons)
        const checkboxOptions = ref([]);
        // Fetch reasons from API when the component is mounted
        onMounted(async () => {
            try {
                const baseUrl = getApiBaseUrl() || process.env.VUE_APP_BASE_URL;
                const response = await axios.get(`${baseUrl}/services/driver-app-end-task-reason`);
                console.log(response.data);
                if (response.data) {
                    // Assuming the response returns an array of objects with `label` and `value`
                    const data = response.data.data.map((reason) => ({
                        label: reason.name, // Assuming `name` is the reason text
                        value: reason.name, // Assuming `id` is the unique identifier
                    }));
                    checkboxOptions.value = data;
                    filterCheckboxOptions.value = data;
                }
            }
            catch (error) {
                console.error("Error fetching reasons:", error);
            }
        });
        const searchQuery = ref("");
        const filterCheckboxOptions = ref([]);
        watch(searchQuery, () => {
            const checkboxFilter = computed(() => {
                if (!searchQuery.value)
                    return checkboxOptions.value;
                return checkboxOptions.value.filter((option) => option.label.toLowerCase().includes(searchQuery.value.toLowerCase()));
            });
            filterCheckboxOptions.value = checkboxFilter.value;
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("p", _hoisted_3, _toDisplayString(props.value), 1),
                    _hoisted_4,
                    _createElementVNode("div", _hoisted_5, [
                        _createVNode(SearchTextBox, {
                            value: searchQuery.value,
                            "onUpdate:value": _cache[0] || (_cache[0] = ($event) => ((searchQuery).value = $event)),
                            placeholder: "Search Reason"
                        }, null, 8, ["value"]),
                        _createVNode(MultiSelectCheckbox, {
                            selectedOption: selectedOptions.value,
                            "onUpdate:selectedOption": _cache[1] || (_cache[1] = ($event) => ((selectedOptions).value = $event)),
                            options: filterCheckboxOptions.value,
                            name: 'reasons'
                        }, null, 8, ["selectedOption", "options"]),
                        (reasonError.value)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_6, "Reason is required."))
                            : _createCommentVNode("", true),
                        _createVNode(CommentBox, {
                            comment: commentText.value,
                            "onUpdate:comment": _cache[2] || (_cache[2] = ($event) => ((commentText).value = $event)),
                            disabled: false
                        }, null, 8, ["comment"]),
                        (commentError.value)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_7, "Comment is required."))
                            : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_8, [
                        _createVNode(DButton, {
                            class: "select-btn",
                            value: "Select & Continue",
                            primary: "",
                            onClick: handleStart
                        }),
                        _createVNode(DButton, {
                            value: "No",
                            secondary: "",
                            onClick: handleClose
                        })
                    ])
                ])
            ]));
        };
    }
});
